// extracted by mini-css-extract-plugin
export var active = "basketNavButton-module--active--ZROHl";
export var basketPopoverBannerContainer = "basketNavButton-module--basket-popover-banner-container--dDnOM";
export var container = "basketNavButton-module--container--pqs6R";
export var loadingPlaceholder = "basketNavButton-module--loading-placeholder--BGVen";
export var number = "basketNavButton-module--number--QiSJ3";